import DOMPurify from 'dompurify';
import { useEffect, useRef } from 'react';

export function SuccessModal({
  onClose,
  title,
  description,
}: {
  onClose: () => void;
  title: string;
  description: string;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    dialogRef.current?.showModal();
  }, []);

  return (
    <dialog
      ref={dialogRef}
      onCancel={onClose}
      className="m-auto p-0 w-full max-w-md rounded-xl shadow-2xl backdrop:bg-black/60"
      aria-label="Tack för ditt bidrag"
    >
      <div className="flex flex-col items-center px-8 py-10 text-center">
        <h2 className="text-2xl font-bold text-dark-blue mb-3">{title}</h2>
        <p
          className="text-dark-blue/70 leading-relaxed"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description),
          }}
        ></p>
        <button
          type="button"
          onClick={onClose}
          className="mt-8 px-8 py-3 bg-dark-blue text-white text-sm font-bold rounded hover:bg-dark-blue/80 transition-colors"
        >
          Stäng
        </button>
      </div>
    </dialog>
  );
}
